import React, { Component, Fragment } from "react";
import InputLabel from '@material-ui/core/InputLabel';
import './InviteUserModal.css';
import EmailTagsInput from './EmailTagsInput';
import { Modal } from 'react-bootstrap';
import Button from "@material-ui/core/Button";
import PropTypes from 'prop-types';
import uniqBy from 'lodash/uniqBy';
import { Collapse, Card, CardBody } from 'reactstrap';
import ExpandMore from '@material-ui/icons/ExpandMore';
import axiosInstance from "../common/AxiosInstace";
import EndpointsGetter from '../common/EndpointsGetter';
import isEmpty from 'lodash/isEmpty';

class InviteUserModal extends Component {
    state = {
        emailAddresses: [],
        emailInvite: '',
        emailsValid: true,
        collapse: false,
        errorString: ''
    };

    hanldeTextAreaChange = (event) => {
        this.setState({ emailInvite: event.target.value });
    }

    handleTextAreaBlur = (event) => {
        this.setState({ emailInvite: event.target.value.trim() });
    }

    setEmailAddresses = (emailAddresses) => {
        this.setState({ emailAddresses, emailsValid: !this.checkForInvalidEmails(emailAddresses) });
    }

    checkForInvalidEmails = (emailAddresses) => {
        let validity = emailAddresses.find((email) => { return !email.isEmail });
        return validity ? true : false;
    }

    inviteUsers = () => {
        let { emailAddresses, emailInvite } = this.state;
        if (this.checkForInvalidEmails(emailAddresses)) {
            this.setState({ emailsValid: false });
        } else {
            this.setState({ emailsValid: true });
            let uniqueEmailsOnly = uniqBy([...emailAddresses], 'val');
            this.sendEmailInvitation(uniqueEmailsOnly, emailInvite);
        }
    }

    sendEmailInvitation = (emails, inviteText) => {
        let emailList = emails.map(email => {
            return email.val;
        });

        let inviteReq = {
            "emailList": emailList ? emailList : [],
            "role": "ROLE_VIEWER",
            "accountName": null
        },
            accessToken = localStorage.getItem("access_token");

        axiosInstance.post(EndpointsGetter.getInviteUserEndpoint(), { ...inviteReq, ...(!isEmpty(inviteText) && { "invitationMessage": inviteText.trim() }) }, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`
            }
        })
            .then(response => {
                this.props.toggleModal();
                this.resetState();
                let message = `You've invited ${emailList.length} user${emailList.length > 1 ? 's' : ''}.`;
                this.props.showMessage(message);
            })
            .catch(error => {
                this.getError(error);
            })
    }

    toggleEmailInvite = () =>
        this.setState(prevState => ({ collapse: !prevState.collapse }));

    getError(error) {
        let errorString = '';
        if (error.code === 'ECONNABORTED') {
            errorString = "API Request timed out. Please try again after few seconds";
        } else if (error.response.status === 500) {
            errorString = "Operation was unsuccessful. Please try again after few seconds";
        } else if (error.response.status === 404) {
            errorString = "Error 404";
        } else if (error.response.status === 401) {
            // errorString = "Unauthorized";
        } else {
            errorString = error.response.data.message ? error.response.data.message : error.response.data.error_description;
            if (error.response.status === 400 && errorString.includes("Invalid refresh token")) {
                this.props.history.push('/login');
            }
        }
        let oldState = { ...this.state };
        oldState.errorString = errorString;
        this.setState(oldState);
    }

    closeModal = () => {
        this.resetState();
        this.props.toggleModal();
    }

    resetState = () => {
        this.setState({
            emailAddresses: [],
            emailInvite: '',
            emailsValid: true,
            collapse: false,
            errorString: ''
        });
    }

    render() {
        const { emailAddresses, emailsValid, collapse, errorString, emailInvite } = this.state,
            { inviteModalShow } = this.props;

        return (
            <Modal
                show={inviteModalShow}
                container={this}
                aria-labelledby="contained-modal-title"
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title">
                        Invite users
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Fragment>
                        We'll invite your new users to the site and onboard them. During signup
                        they'll enter their full name.

                        <div className="email-section">
                            {
                                errorString ? (
                                    <label className="text-area-label col-lg-6" style={{ color: 'red', padding: '0' }}>
                                        {errorString}
                                    </label>
                                ) : null
                            }
                            <EmailTagsInput
                                emailAddresses={emailAddresses}
                                setEmailAddresses={this.setEmailAddresses}
                                emailsValid={emailsValid}
                            />
                            <InputLabel
                                onClick={this.toggleEmailInvite}
                                style={{ marginTop: '20px', flexDirection: 'row', display: 'flex' }}
                            >
                                <div className='expand-icon'>
                                    <ExpandMore className={collapse ? 'arrow-up' : 'arrow'} />
                                </div>
                                Personalize email invite
                            </InputLabel>
                            <Collapse
                                isOpen={this.state.collapse}
                            >
                                <Card>
                                    <CardBody>
                                        <InputLabel
                                            htmlFor="custom-css-textarea"
                                            style={{ marginTop: '10px' }}
                                        >
                                            Email Invite
                                        </InputLabel>
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <textarea
                                                id='custom-css-textarea'
                                                rows='8'
                                                cols='50'
                                                className='email-textarea'
                                                value={emailInvite}
                                                onBlur={this.handleTextAreaBlur}
                                                onChange={this.hanldeTextAreaChange}
                                            >
                                            </textarea>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Collapse>
                        </div>
                    </Fragment>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        style={{ marginRight: '12px' }}
                        variant="outlined"
                        color="secondary"
                        onClick={this.inviteUsers}
                        disabled={isEmpty(emailAddresses) || this.checkForInvalidEmails(emailAddresses)}
                    >
                        {emailAddresses.length > 1 ? 'Invite users' : 'Invite user'}
                    </Button>
                    <Button variant="outlined" color="secondary" onClick={this.closeModal}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

InviteUserModal.propTypes = {
    inviteModalShow: PropTypes.bool,
    toggleModal: PropTypes.func
}

export default InviteUserModal;



// WEBPACK FOOTER //
// ./src/main/content/user-management/InviteUserModal.js